import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-header">
        <div className="container">
          <Link to="/" className="back-link">← Back to Home</Link>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      <div className="privacy-content">
        <div className="container">
          <div className="content-wrapper">
            
            <section className="privacy-section">
              <h2>1. Introduction</h2>
              <p>
                Ludic Labs Technology Limited ("we," "our," or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
                or use our mobile games and services.
              </p>
            </section>

            <section className="privacy-section">
              <h2>2. Information We Collect</h2>
              <h3>2.1 Personal Information</h3>
              <p>We may collect personal information that you voluntarily provide to us, including:</p>
              <ul>
                <li>Name and contact information</li>
                <li>Email address</li>
                <li>Device information and identifiers</li>
                <li>Game progress and achievements</li>
              </ul>

              <h3>2.2 Automatically Collected Information</h3>
              <p>When you use our games or visit our website, we may automatically collect:</p>
              <ul>
                <li>IP address and location data</li>
                <li>Device type, operating system, and browser information</li>
                <li>Game usage statistics and performance data</li>
                <li>Advertising identifiers</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>3. How We Use Your Information</h2>
              <p>We use the collected information for the following purposes:</p>
              <ul>
                <li>To provide and maintain our games and services</li>
                <li>To improve game performance and user experience</li>
                <li>To personalize content and advertisements</li>
                <li>To communicate with users about updates and support</li>
                <li>To analyze usage patterns and optimize our services</li>
                <li>To comply with legal obligations</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>4. Information Sharing and Disclosure</h2>
              <p>We may share your information in the following circumstances:</p>
              <ul>
                <li><strong>Third-Party Service Providers:</strong> We may share data with trusted partners who help us operate our services</li>
                <li><strong>Advertising Partners:</strong> We may share advertising identifiers with ad networks to show relevant ads</li>
                <li><strong>Legal Requirements:</strong> We may disclose information when required by law or to protect our rights</li>
                <li><strong>Business Transfers:</strong> Information may be transferred in connection with mergers or acquisitions</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
                the internet or electronic storage is 100% secure.
              </p>
            </section>

            <section className="privacy-section">
              <h2>6. Children's Privacy</h2>
              <p>
                Our games may be suitable for children, but we do not knowingly collect personal information from children 
                under 13 years of age without parental consent. If you are a parent or guardian and believe we have collected 
                information from your child, please contact us immediately.
              </p>
            </section>

            <section className="privacy-section">
              <h2>7. International Data Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your country of residence. 
                We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards.
              </p>
            </section>

            <section className="privacy-section">
              <h2>8. Your Rights</h2>
              <p>Depending on your location, you may have the following rights regarding your personal information:</p>
              <ul>
                <li>Right to access your personal data</li>
                <li>Right to rectify inaccurate information</li>
                <li>Right to erase your personal data</li>
                <li>Right to restrict processing</li>
                <li>Right to data portability</li>
                <li>Right to object to processing</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>9. Cookies and Tracking Technologies</h2>
              <p>
                We use cookies and similar tracking technologies to enhance your experience on our website and in our games. 
                You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="privacy-section">
              <h2>10. Updates to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any material changes by posting 
                the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="privacy-section">
              <h2>11. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us:</p>
              <div className="contact-info">
                        <p><strong>Ludic Labs Technology Limited</strong></p>
        <p>Email: support@ludiclabstech.com</p>
        <p>Address: RM A5,7/F, ASTORIA BUILDING, NO.34 ASHLEY ROAD, TSIM SHA TSUI HONG KONG</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
